import axios from 'axios'
import { warehouseUrl, getHeader } from '@/config'

const state = {
  warehouseList: []
}

const mutations = {
  SET_WAREHOUSE_LIST (state, obj) {
    state.warehouseList = obj
  }
}

const actions = {
  getWarehouseList: ({ commit }) => {
    axios.get(warehouseUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_WAREHOUSE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
